import { Raw } from '@/modules/common/helpers/api';
import { OrderIntent, OrderType, TimeInForceType } from '@/modules/marketplace/types/marketplace';
import Decimal from 'decimal.js';

export type RawOmsOrderRequestDetails = Raw<OmsOrderRequestDetails>;

export class OmsOrderRequestDetails {
  public quantity: number;
  public minQuantity: number;
  public rate: Decimal | null;
  public rateType: 'FEE' | 'REBATE';
  public agreementIds: string[];
  public orderType: OrderType;
  public orderIntent: OrderIntent;
  public timeInForceType: TimeInForceType;
  public goodTillTime: Date | null;
  public isAnonymous: boolean;
  public allowOddLots: boolean;
  public active: boolean;

  protected constructor(data: OmsOrderRequestDetails) {
    this.quantity = data.quantity;
    this.minQuantity = data.minQuantity;
    this.rate = data.rate;
    this.rateType = data.rateType;
    this.agreementIds = data.agreementIds;
    this.orderType = data.orderType;
    this.orderIntent = data.orderIntent;
    this.timeInForceType = data.timeInForceType;
    this.goodTillTime = data.goodTillTime;
    this.isAnonymous = data.isAnonymous;
    this.allowOddLots = data.allowOddLots;
    this.active = data.active;
  }

  public static toData(model: OmsOrderRequestDetails): RawOmsOrderRequestDetails {
    return {
      quantity: model.quantity,
      minQuantity: model.minQuantity,
      rate: model.rate?.toString() ?? null,
      rateType: model.rateType,
      agreementIds: model.agreementIds,
      orderType: model.orderType,
      orderIntent: model.orderIntent,
      timeInForceType: model.timeInForceType,
      goodTillTime: model.goodTillTime === null ? null : model.goodTillTime.toISOString(),
      isAnonymous: model.isAnonymous,
      allowOddLots: model.allowOddLots,
      active: model.active,
    };
  }
}
